<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Выдача разрешений заявки на охоту') }}</h1>
    <div class="my-organization">
      <div class="create-quota-pg view bgw-pdg-20">
        <p class="status text-center">
          {{ $t('Статус') }}: {{ licenseApplication.statusName }}
        </p>
        <h4 class="text-center">{{ $t('Заявка на охоту на добычу диких животных') }} {{ licenseApplication.ooptName }}</h4>
        <div class="form-group">
          <div class="quota-fields justify-content-between">
            <div class="quota-field field-column">
              <p>{{ $t('Дата') }}: {{ licenseApplication.date }} № {{ licenseApplication.number }}</p>
            </div>
            <div class="quota-field">
              <p>
                <strong>{{ $t('Тип') }}: {{ licenseApplication.typeName }}</strong>
              </p>
            </div>
            <div class="quota-field">
              <p>{{ $t('Отправитель') }}: {{ licenseApplication.userFio }}</p>
            </div>
          </div>
        </div>
        <FaunaLicenses :licenseApplication="licenseApplication.id" :faunaLicenses="faunaLicenses" :editable="true" :foreignCitizenTypeFlag="licenseApplication.type === foreignCitizenType"/>
        <div class="quota-bottom">
          <PayInfo :licenseApplication="licenseApplication" />
        </div>
        <div class="quota-bottom">
          <Documents v-bind:documents.sync="documents" :editable="false" :applicationId="licenseApplication.id"/>
        </div>
        <FaunaLicenseApplicationBsos :licenseApplication="licenseApplication.id" v-bind:bsos.sync="faunaLicenseApplicationBsos" :editable="true" :issueDate="licenseApplication.issueDate"/>
        <label v-if="bsoParentError" class="invalid">{{ $t('Заполните блок "Выданных БСО"') }}</label>
        <div class="quota-bottom">
          <v-form ref="form" @submit.prevent="allocateApplication" lazy-validation>
            <!--Вход. номер - Дата получения-->
            <div class="form-group">
              <div class="quota-fields">
                <div class="quota-field" :class="{ invalid: $v.licenseApplication.incomingNumber.$error }">
                  <label>{{ $t('Вход. номер') }}:</label>
                  <v-text-field
                    v-model="licenseApplication.incomingNumber"
                    outlined
                    dense
                    class="size-small"
                  />
                </div>
                <div class="quota-field datepicker-main" :class="{ invalid: $v.licenseApplication.incomingDate.$error }">
                  <label>{{ $t('Дата получения') }}:</label>
                  <div class="form-date">
                    <v-icon class="date-icon">date_range</v-icon>
                    <VueCtkDateTimePicker
                      v-model="licenseApplication.incomingDate"
                      format="DD.MM.YYYY"
                      formatted="LL"
                      :onlyDate="true"
                      :label="$t('Дата')"
                      :autoClose="true"
                      :noButton="true"
                    />
                  </div>
                </div>
                <div class="quota-field datepicker-main" :class="{ invalid: $v.licenseApplication.issueDate.$error }">
                  <label>{{ $t('Дата выдачи') }}:</label>
                  <div class="form-date">
                    <v-icon class="date-icon">date_range</v-icon>
                    <VueCtkDateTimePicker
                      v-model="licenseApplication.issueDate"
                      format="DD.MM.YYYY"
                      formatted="LL"
                      :onlyDate="true"
                      :label="$t('Дата')"
                      :autoClose="true"
                      :noButton="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--Реквизиты документа - Дата обработки-->
            <div class="form-group">
              <div class="quota-fields justify-space-between">
                <div class="quota-field textarea-field" :class="{ invalid: $v.licenseApplication.documentsDetails.$error }">
                  <label>{{ $t('Реквизиты документа') }}:</label>
                  <v-textarea
                    v-model="licenseApplication.documentsDetails"
                    outlined
                    dense
                    class="size-small"
                  />
                </div>
                <div class="quota-field datepicker-main" :class="{ invalid: $v.licenseApplication.processingDate.$error }">
                  <label>{{ $t('Дата обработки') }}:</label>
                  <div class="form-date">
                    <v-icon class="date-icon">date_range</v-icon>
                    <VueCtkDateTimePicker
                      v-model="licenseApplication.processingDate"
                      format="DD.MM.YYYY"
                      formatted="LL"
                      :onlyDate="true"
                      :label="$t('Дата')"
                      :autoClose="true"
                      :noButton="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--Файл-->
            <div class="form-group" :class="{ invalid: $v.licenseFile.$error }">
              <div class="quota-field" v-if="licenseApplication.file">
                <template
                  v-if="checkFileExist(licenseApplication.fileExtension)"
                >
                  <a
                    @click="previewDocumentDialog(licenseApplication.id, true)"
                  >{{ $t('Файл ответа') }}</a>
                  <v-dialog
                    v-model="previewDocsModal[licenseApplication.id]"
                    max-width="1200"
                  >
                    <v-card class="modal">
                      <div class="modal-head">
                        {{ $t('Файл ответа') }}
                        <v-btn
                          color="modal-close"
                          @click="previewDocumentDialog(licenseApplication.id, false)"
                        >
                          <img src="@/assets/img/close-icon.png" alt="icon">
                        </v-btn>
                      </div>
                      <div class="modal-body">
                        <VueDocPreview
                          :value="backUrl + licenseApplication.file"
                          type="office"
                        />
                      </div>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-else>
                  <a
                    :href="backUrl + licenseApplication.file"
                    target="_blank"
                  >{{ $t('Файл ответа') }}</a>
                </template>
              </div>
              <div class="file-input-link upload-file">
                <v-file-input
                  :label="$t('Загрузить файл документа')"
                  v-model="licenseFile"
                  clearable
                  ref="file"
                  @change="handleFileUpload()"
                  :error="$v.licenseFile.$error"
                />
              </div>
            </div>
            <!--Комментарий-->
            <div class="form-group">
              <div class="quota-fields">
                <div class="quota-field textarea-field">
                  <label>{{ $t('Комментарий') }}:</label>
                  <v-textarea
                    v-model="licenseApplication.comment"
                    outlined
                    dense
                    class="size-small"
                  />
                </div>
              </div>
            </div>
            <div class="form-action">
              <button
                class="btn btn-default"
                type="submit"
                @click="statusId = consideredStatus"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default blue"
                type="submit"
                @click="statusId = processedStatus"
              >
                {{ $t('Утвердить') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import License from '@/model/license'
import Documents from '@/components/license/Documents'
import FaunaLicenses from '@/components/license/FaunaLicenses'
import PayInfo from '@/components/license/PayInfo'
import FaunaLicenseApplicationBsos from '@/components/license/FaunaLicenseApplicationBsos'
import VueDocPreview from 'vue-doc-preview'
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  components: {
    Documents,
    FaunaLicenses,
    PayInfo,
    FaunaLicenseApplicationBsos,
    VueDocPreview
  },
  data: () => ({
    breadcrumbs: [],
    licenseApplication: {},
    backUrl: process.env.VUE_APP_BACK_URL,
    foreignCitizenType: null,
    faunaLicenses: [],
    documents: [],
    previewDocsModal: [],
    licenseFile: null,
    faunaLicenseApplicationBsos: [],
    statusId: null,
    consideredStatus: null,
    processedStatus: null,
    history: {},
    bsoParentError: false,
    rules: {
      licenseApplication: {
        incomingNumber: { required },
        incomingDate: { required },
        documentsDetails: { required },
        processingDate: { required },
        issueDate: { required }
      },
      licenseFile: {
        required: requiredIf(function () {
          return this.licenseApplication.file === null
        })
      }
    }
  }),
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData () {
      this.setLoading(true)
      License.showApplication(this.$route.params.id).then((response) => {
        this.licenseApplication = response.data.applicationPermit
        this.foreignCitizenType = response.data.foreignCitizenType
        this.consideredStatus = response.data.consideredStatus
        this.processedStatus = response.data.processedStatus
        this.faunaLicenses = response.data.faunaLicenses
        this.documents = response.data.documents
        this.history = response.data.lastHistory
        // если нет "Дата получения", то по умолчанию ставим текущую дату
        if (this.licenseApplication.incomingDate == null) {
          this.licenseApplication.incomingDate = moment(new Date()).format('DD.MM.YYYY')
        }
        if (this.history.comment) {
          this.licenseApplication.comment = this.history.comment
        }
        this.getFaunaLicenseApplicationBsos()
        this.generateBreadcrumbs()
        this.scrollToTop()
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    // Выданные БСО
    getFaunaLicenseApplicationBsos () {
      License.getFaunaLicenseApplicationsWithBsos(this.$route.params.id).then((response) => {
        this.faunaLicenseApplicationBsos = response.data.faunaLicenseApplications
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
    },
    // Сохранение
    allocateApplication () {
      if (!this.validateForm()) {
        return
      }
      let bsoParentCheck = true
      Object.entries(this.faunaLicenseApplicationBsos).forEach(([bsoKey, bso]) => {
        if (bso.strictReportingFormTypes) {
          if (bso.strictReportingFormTypes.shooting_card) {
            Object.entries(bso.strictReportingFormTypes.shooting_card.faunaLicenseApplicationBsos).forEach(([shootingCardKey, shootingCard]) => {
              if (shootingCard.parent === null) {
                bsoParentCheck = false
              }
            })
          }
          if (bso.strictReportingFormTypes.trophySheet) {
            Object.entries(bso.strictReportingFormTypes.trophySheet.faunaLicenseApplicationBsos).forEach(([trophySheetKey, trophySheet]) => {
              if (trophySheet.parent === null) {
                bsoParentCheck = false
              }
            })
          }
        }
      })
      this.bsoParentError = false
      if (!bsoParentCheck) {
        this.$noty.error(this.$i18n.t('Внимание! Необходимо отстрелочные карты и трофейные листы привязать к разрешению'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        this.bsoParentError = true
        return
      }

      this.setLoading(true)

      const formEl = this.$refs.form.$el
      const fd = new FormData(formEl)
      fd.append('application_permit_approve[incomingNumber]', this.licenseApplication.incomingNumber)
      fd.append('application_permit_approve[incomingDate]', this.licenseApplication.incomingDate)
      fd.append('application_permit_approve[processingDate]', this.licenseApplication.processingDate)
      fd.append('application_permit_approve[documentDetails]', this.licenseApplication.documentsDetails)
      if (this.licenseApplication.comment) {
        fd.append('comment', this.licenseApplication.comment)
      }
      fd.append('application_permit_approve[uploadedFile]', this.licenseFile)
      fd.append('application_permit_approve[issueDate]', this.licenseApplication.issueDate)

      License.approveApplication(this.$route.params.id, this.statusId, fd).then((response) => {
        this.onCancel()
        this.setLoading(false)
      }).catch((error) => {
        console.log(error)
        this.setLoading(false)
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на охоту'),
          disabled: false,
          href: '/license-application-list/'
        },
        {
          text: this.$i18n.t('Выдача разрешений заявки на охоту'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    handleFileUpload () {
      if (this.licenseFile) {
        this.createFile(this.licenseFile)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    // отмена
    onCancel () {
      this.$router.push({
        name: 'license-application-view',
        params: {
          id: this.$route.params.id
        }
      })
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.quota-bottom {
  .table-overflow {
    margin-bottom: 30px;
    table {
      td {
        p {
          margin-bottom: 2px;
        }
      }
    }
  }
}
.form-action {
  margin-top: 40px;
}
.quota-field {
  margin-right: 8px;
}
</style>
